import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

/**
 * The admin tables share `.tableview` from style.scss plus a trailing-colon header convention
 * ("Project:", "Task Item:"). Both were being re-typed per page, so they live here instead.
 *
 * Rows stay as children rather than a data prop - the cells differ too much between pages
 * (chips, links, inputs) for a column-renderer abstraction to earn its keep.
 */

const headCellStyle = {
  color: '#979598',
  fontFamily: 'Red Hat Display SemiBold',
  fontSize: 12,
};

export const commonTableCellStyle = {
  color: '#292929',
  fontFamily: 'Red Hat Display Medium',
  fontSize: 13,
};

type TableProps = {
  headers: string[];
  children: ReactNode;
  size?: 'small' | 'medium';
  className?: string;
};

const CommonTable = (props: TableProps): ReactElement => {
  const { headers, children, size, className } = props;

  return (
    <Table
      size={size ?? 'small'}
      className={`tableview ${className ?? ''}`.trim()}>
      <TableHead>
        <TableRow>
          {headers.map((header: string) => (
            <TableCell key={header} sx={headCellStyle}>
              {header.endsWith(':') ? header : `${header}:`}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
    </Table>
  );
};

export default CommonTable;
